import { Button } from '@kerfjs/ui/button';
import { LucideIcon } from '@kerfjs/ui/lucide-icon';
import { DialogSurface } from '@kerfjs/ui/surface-scaffold';
import { Text } from '@kerfjs/ui/text';
import { TextField } from '@kerfjs/ui/text-field';
import type { SafeHtml } from 'kerfjs';
import { Bot } from 'lucide';

import type { BackgroundDocT, FactT } from '../../../data/api.js';
import { sourceLabel } from './library-fact-source.js';

/** Create or edit one accepted Knowledge Base fact. */
export function LibraryFactDialog({
  fact,
  docs,
  open,
}: {
  fact: FactT | undefined;
  docs: readonly BackgroundDocT[];
  open: boolean;
}): SafeHtml {
  if (!open) return <></>;
  return (
    <DialogSurface
      className="library-fact-dialog"
      label={fact === undefined ? 'New Fact' : 'Edit Fact'}
      rootAttributes={{ 'data-action': 'lib-fact-dialog', 'data-auto-open-dialog': '' }}
      footer={
        <>
          <Button tone="neutral" size="default" emphasis="plain" action="lib-fact-cancel">
            Cancel
          </Button>
          {fact === undefined ? null : (
            <Button tone="neutral" size="default" emphasis="plain" rootAttributes={{ 'data-fact-delete': fact.id }}>
              Delete
            </Button>
          )}
          <Button size="default" tone="brand" emphasis="primary" action="lib-fact-save">
            Save
          </Button>
        </>
      }
    >
      <TextField multiline name="lib-fact-text" label="Fact" rows={5} maxLength={1000} value={fact?.text ?? ''} />
      {fact === undefined ? null : (
        <Text tone="quiet" size="compact">
          {fact.sourceKind === 'ai' || fact.sourceDocumentId !== null ? (
            <LucideIcon icon={Bot} name="AI" size="s" />
          ) : null}
          {sourceLabel(fact, docs)}
        </Text>
      )}
    </DialogSurface>
  );
}
